import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function PromotionEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function PromotionCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"promotion"} children={children} />
    );
}